import React, { forwardRef, lazy, Suspense } from 'react';
import { cx } from 'class-variance-authority';
import { LazyImage, ProgressBar } from '@crehana/compass.ui';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var LazyPlayroomRewardIndicatorWithRive = /*#__PURE__*/lazy(function () {
  return import("../CardCoins").then(function (module) {
    return {
      "default": module["default"]
    };
  });
});
var ImageCard = function ImageCard(_ref, ref) {
  var backgroundImgParams = _ref.backgroundImgParams,
    backgroundImg = _ref.backgroundImg,
    title = _ref.title,
    subtitle = _ref.subtitle,
    bottomElement = _ref.bottomElement,
    onCTAClick = _ref.onCTAClick,
    className = _ref.className,
    labelState = _ref.labelState,
    progress = _ref.progress,
    coins = _ref.coins;
  return /*#__PURE__*/_jsxs("button", {
    className: cx('tw-relative tw-overflow-hidden tw-rounded-2 tw-min-h-14.4 tw-flex tw-flex-col tw-justify-end',
    // Background overlay
    "after:content-[''] after:tw-absolute after:tw-top-0 after:tw-left-0 after:tw-w-full after:tw-h-full after:tw-z-1 after:tw-bg-neutral-dark-800 after:tw-opacity-20",
    // Hover shadow
    'tw-transition-shadow tw-duration-200 tw-ease-in-out hover:tw-shadow-02 dark:tw-shadow-elevation-dark-02',
    // Group
    'tw-group', className),
    type: "button",
    onClick: onCTAClick,
    "aria-label": title,
    "data-testid": "content-category-card",
    ref: ref,
    children: [labelState && /*#__PURE__*/_jsx("span", {
      className: "tw-bg-[#ffffff66] tw-w-fit tw-font-subtitle5 tw-mb-auto tw-ml-2.4 tw-px-1.2 tw-py-0.4 tw-relative tw-rounded-[12rem] tw-text-neutral-light-100 tw-top-2.4 tw-z-2",
      children: labelState
    }), backgroundImg && /*#__PURE__*/_jsx(LazyImage, {
      src: backgroundImg,
      alt: title,
      className: "tw-w-full tw-h-full tw-absolute tw-top-0 tw-left-0 tw-z-0 group-hover:tw-scale-110 tw-transition-transform tw-duration-1000 tw-ease-in-out",
      imgClassName: "tw-object-cover tw-w-full tw-h-full",
      imgxParams: {
        fit: 'crop',
        crop: 'faces',
        q: (backgroundImgParams === null || backgroundImgParams === void 0 ? void 0 : backgroundImgParams.quality) || 100,
        w: backgroundImgParams === null || backgroundImgParams === void 0 ? void 0 : backgroundImgParams.width,
        h: backgroundImgParams === null || backgroundImgParams === void 0 ? void 0 : backgroundImgParams.height
      }
    }), /*#__PURE__*/_jsxs("div", {
      className: "tw-z-2 tw-text-neutral-light-100 tw-p-1.6 md:tw-p-2.4 tw-text-left",
      children: [/*#__PURE__*/_jsx("h3", {
        className: "tw-font-subtitle1 tw-mb-0.8 tw-line-clamp-2 sm:tw-line-clamp-3",
        children: title
      }), !!subtitle && /*#__PURE__*/_jsx("div", {
        className: "tw-font-body3",
        children: subtitle
      }), /*#__PURE__*/_jsxs("div", {
        className: cx('tw-flex tw-items-center tw-mt-1.2', {
          'tw-hidden': !progress
        }),
        children: [/*#__PURE__*/_jsx(ProgressBar, {
          detailBackground: {
            background: 'tw-bg-neutral-dark-600',
            progressBar: 'tw-bg-warning-300'
          },
          progress: progress !== null && progress !== void 0 ? progress : 0,
          size: "s",
          className: "tw-rounded-2.4 !tw-w-8 tw-h-0.8 tw-relative [&>span]:tw-rounded-0 tw-mr-1.2"
        }), coins && coins > 0 && /*#__PURE__*/_jsx(Suspense, {
          fallback: null,
          children: /*#__PURE__*/_jsx(LazyPlayroomRewardIndicatorWithRive, {
            coins: coins
          })
        })]
      }), !!bottomElement && /*#__PURE__*/_jsx("div", {
        className: "tw-mt-0.8",
        children: bottomElement
      })]
    })]
  });
};
export default /*#__PURE__*/forwardRef(ImageCard);